export const SpinnerContainerStyle: React.CSSProperties = {
  alignContent: 'center',
  height: '100%',
  justifyContent: 'center',
  padding: '100px',
  width: '100%',
};
